import { Component, inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { MobileMenuService } from '../../services/mobile-menu.service';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss'],
    imports: [NgClass, RouterLink]
})
export class MobileMenuComponent {
  auth = inject(AuthService);
  mobileMenuService = inject(MobileMenuService);

}
